export default "__VITE_ASSET__DDiMWBBC__"